import type { DeepPartial } from '@nuxt/ui'
import type theme from '#build/ui/modal'

const modal: DeepPartial<typeof theme> = {
  slots: {
    overlay: 'transitions-extra-slow backdrop-blur bg-med-dark-gray opacity-50',
    content: 'transitions-extra-slow max-w-[80%] rounded-lg shadow-lg bg-primary',
    header: 'laptop:px-5 px-4 border-none',
    body: 'laptop:p-5 flex-1 p-4 text-cvt-text-black text-base font-normal leading-5',
    footer: 'flex items-center gap-1.5 p-4 sm:px-6',
    title: 'font-semibold text-gray-900 dark:text-white',
    description: 'mt-1 text-sm text-gray-500 dark:text-gray-400',
    close: 'absolute right-[20px] top-[27px] cursor-pointer p-2 [&>span]:size-5 text-white border-none',
  },
  variants: {
    fullscreen: {
      false: {
        content: 'ring-0 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 md:my-8 lg:max-w-[954px]',
      },
    },
  },
}

export default modal
